import { Link } from "@/components/catalyst/Link";

export function Partner() {
	return (
		<div className="mt-4 pt-4 border-t border-zinc-200 dark:border-zinc-800">
			<p className="text-center text-sm text-zinc-500 dark:text-zinc-400">
				Looking for the{" "}
				<Link
					href="/partner"
					className="text-zinc-600 dark:text-zinc-300 hover:text-zinc-900 dark:hover:text-white underline underline-offset-2"
				>
					Partner Portal
				</Link>
				?
			</p>
		</div>
	);
}
